export default __webpack_public_path__ + "other/versions.txt";